/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
==========================================================================================*/

import moment from "moment-business-days";

export default [
  {
    url: null,
    name: 'Home',
    tagColor: 'primary',
    icon: 'HomeIcon',
    i18n: 'Home',
    submenu: [
      {
        name: 'Dashboard',
        i18n: 'Dashboard',
        url: '/broker/dashboard',
        slug: 'dashboard',
      },
    ]
    
  },
  {
    header: 'People',
    icon: 'LayersIcon',
    i18n: 'People',
    items: [
      {
        url: null,
        name: 'Contacts',
        tagColor: 'primary',
        icon: 'UsersIcon',
        i18n: 'Contacts',
        url: '/broker/people/people-list'
      },
    ]
  },
  {
    header: 'Sales',
    icon: 'LayersIcon',
    i18n: 'Sales',
    items: [

      {
        url: null,
        name: 'Quotation',
        tagColor: 'primary',
        icon: 'DollarSignIcon',
        url: '/broker/quotation/quotation-list' ,
        i18n: 'Quotations',
       /* submenu: [
          {
            name: 'List',
            icon: 'ActivityIcon',
            url: '/broker/quotation/quotation-list' ,
            slug: 'Quotations',
          },
          {
            name: 'Overdue',
            icon: 'ActivityIcon',
            url: '/broker/dashboard/quotation',
            slug: 'Quotation',
          },
        ]*/
      },
      {
        url: null,
        tagColor: 'primary',
        icon: 'UploadIcon',
        name: 'Invoices',
        slug: 'Invoices',
        i18n: 'Invoices',
        submenu: [
          {
            name: 'List',
            icon: 'ActivityIcon',
            url: '/broker/invoice/invoice-list',
            slug: 'Invoices',
          },
          {
            name: 'Overdue',
            icon: 'ActivityIcon',
            url: '/broker/dashboard/finance',
            slug: 'Overdue',
          },
        ]
      }
    ]
  },
]